module.exports = ".blue_text{\n\tcolor: #1427e6;\n\tmargin: 0px;\n\topacity: 1;\n}\n\nh2.blue_text{\n\tfont-size: 21px;\n}\n\n.para_block{\n\tmargin-top: 32px;\n\tmargin-bottom: 32px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-enroll/setup-autopay/setup-autopay.component.css
// module id = ./src/app/customer-enroll/setup-autopay/setup-autopay.component.css
// module chunks = main